import BtnLayoutOptions from './btn-layout-options';

export default BtnLayoutOptions;